export const breadcrumbsContent = {
    'dari': {
        "List of Admins": "لیست مدیران (ادمین‌ها)",
        "Add Admin": "مدیریت مدیر",
        "Edit Admin": "تصحیح مدیر (ادمین)",
        "Admin Management": "مدیریت مدیر",
        "Personal Details": "اطلاعات شخصی",
        "Residential Details": "آدرس محل سکونت",
        "Upload SOP (Standard Operating Procedure)": "رهنمود استندرد عملیاتی را ردر سیستم بارگزاری نمایید",
        "Upload": "بارگزاری",
        "or": "یا",
        "Drag & Drop": "بکشید و رها کنید",
        "Supported file types: jpg, png, jpeg and pdf format": "pdf و jpg,png,jpeg فایل‌های قابل پشتیبانی: فارمت",
        "Access Module": "طرزالعمل‌های دسترسی",
        "Mark as Super Admin": "علامت گذاری به عنوان مدیر ارشد",
        "Export": "وارد کردن فایل",
        "Filter": "فیلتر",
        "Filter By": "فیلتر بر اساس",
        "Date Range": "محدوده تاریخی",
        "Start Date": "تاریخ آغاز",
        "End Date": "تاریخ ختم",
        "Clear All": "حذف کامل",
        "Apply": "انجام دستور",
        "Status": "وضعیت",
        "Active": "فعال",
        "Inactive": "غیر فعال",
        "All": "تمام موارد",
        "No results found": "نتیجه‌ای دریافت نشد",
        "Try adjusting your filter’s or search criteria": "معیار جستجو یا فیلتر خود را تغییر دهید",
        "List exported successfully": "لیست با موفقیت وارد شد",
        "Verify": "تایید نمایید",
        "List of Master Distributors": "فهرست توزیع‌کنندگان ارشد(ماستر)",
        "Master Distributor Management": "مدیریت توزیع‌کنندگان ارشد (ماستر)",
        "Add Master Distributor": "اضافه کردن توزیع‌کننده ارشد (ماستر)",
        "User Management": "مدیریت کاربران",
        "Wallet Access": "امضا",
        "Max file size: 10MB": "10 MB :حداکثر حجم فایل"


    },
    'pashto': {
        "List of Admins": "د اډمېنانو لېست",
        "Add Admin": "د مدیر اضافه کول",
        "Edit Admin": "د مدیر ( اډمېن) سمول",
        "Admin Management": "د مدیر (اډمېن) مدیریت",
        "Personal Details": "شخصي جزئیات",
        "Residential Details": "د استوګنې د ځای جزئیات",
        "Upload SOP (Standard Operating Procedure)": "معیاري عملیاتي کړنلاره پورته کړئ",
        "Upload": "سیستم ته پورته کول",
        "or": "یا",
        "Drag & Drop": "را کش کړئ او خوشي کړئ",
        "Supported file types: jpg, png, jpeg and pdf format": "بڼې لرونکي فایلونه د  استعمال وړ دي pdf او jpg,png,jpeg د",
        "Access Module": "د لاسرسي لارښود",
        "Mark as Super Admin": "د لوی مدیر په توګه نښاني کول",
        "Export": "د فایل واردول",
        "Filter": "فېلتر",
        "Filter By": "فېلتر د ... پر اساس",
        "Date Range": "د نېټې محدوده",
        "Start Date": "د پیل نېټه",
        "End Date": "د پای نېټه",
        "Clear All": "په بشپړ ډول پاکول",
        "Apply": "د کار اجرا کول",
        "Status": "حالت",
        "Active": "فعال",
        "Inactive": "غیر فعال",
        "All": "ټول موارد",
        "No results found": "پایله پیدا نه شوه",
        "Try adjusting your filter’s or search criteria": "د خپل فېلتر بدلول یا د معیار لپاره پلټنه",
        "List exported successfully": "لېست په بریالیتوب سره دننه کړل شو",
        "Verify": "تایید یې کړئ",
        "List of Master Distributors": "د لوړ پوړو توزیع کونکو (ماسټر) لیست",
        "Master Distributor Management": "د لوړ پوړو توزیع کونکو (ماسټر) مدیریت",
        "Add Master Distributor": "د لوړ پوړو توزیع کونکو (ماسټر) اضافه کړئ",
        "User Management": "د کاروونکو مدیریت",
        "Wallet Access": "لاسلیک",
        "Max file size: 10MB": "10MB :د دوتنې اعظمي اندازه"

    },
    'uzbeki': {
        "List of Admins": "مدیرلر رویخطی (ادمینلر)",
        "Add Admin": "مدیرنی قوشیش",
        "Edit Admin": "مدیر (ادمین)نی توغریلش",
        "Admin Management": "مدیر باشقرووی",
        "Personal Details": "شخصی معلومات",
        "Residential Details": "یشش محللینگیز آدرسی",
        "Upload SOP (Standard Operating Procedure)": "عملیاتی استندرد رهنمالیگینی سیستمگه یوکلنگ",
        "Upload": "یوکلنگ",
        "or": "یا",
        "Drag & Drop": "چیقاریب آلیب تشلنگ",
        "Supported file types: jpg, png, jpeg and pdf format": "pdf و jpg,png,jpeg قوللب قووتلنه دیگن فایللر:  فارمت",
        "Access Module": "کیریش طرزالعمللر",
        "Mark as Super Admin": "کته مدیر صفتیده بیلگیلش",
        "Export": "فایل نی کیریتیش",
        "Filter": "فیلتر",
        "Filter By": "فیلتر اساسیده",
        "Date Range": "تاریخی محدوده",
        "Start Date": "باشله نیش تاریخی",
        "End Date": "یکونی تاریخ",
        "Clear All": "بوتونله ی حذف",
        "Apply": "دستور بجریلیشی",
        "Status": "وضعیت",
        "Active": "فعال",
        "Inactive": "غیر فال",
        "All": "برچه موردلر",
        "No results found": "نتیجه تاپیلمه‌دی",
        "Try adjusting your filter’s or search criteria": "قیدیریش معیاری یا فیلترینگیزنی اوزگرتیرینگ",
        "List exported successfully": "رویخط موفقیت بیلن کیریتیلدی",
        "Verify": "تصدیقلنگ",
        "List of Master Distributors": "اساسی توزیع قیلوچیلر رویخطی",
        "Master Distributor Management": "اساسی توزیع قیلوچیلر باشقرووی",
        "Add Master Distributor": "اساسی توزیع قیلوچیلرنی قوشینگ",
        "User Management": "فایده‌لنوچی باشقرووی",
        "Wallet Access": "امضا",
        "Max file size: 10MB": "10MB: ماکسیمال فایل حجمی"
    }
};